import { useCallback } from 'react'
import { REPOSITORY } from '../../../api/repository/Repository'
import {
  formatCostCenter,
  formatGroup,
  formatOffice,
} from '../../formats/formats'

export const useCompanyData = () => {
  const searchCompanyData = useCallback(async (sEmpresa) => {
    if (sEmpresa) {
      const data = await REPOSITORY.wsEmpresa.company.getCompanyData(sEmpresa)
      const { lSucursal, lCentroCosto, lGrupo } = data.data

      const localDataFormated = {
        sSucursal: formatOffice(lSucursal),
        sCentroCosto: formatCostCenter(lCentroCosto),
        lGrupo: formatGroup(lGrupo),
        sEmpresa,
      }
      REPOSITORY.local.company.setCompanyData(localDataFormated)
    }
  }, [])
  return { searchCompanyData }
}
